import { removeCookieByName } from '@benzinga/utils';

export const cookieCleaner = () => {
  // Remove egregious cookies
  try {
    // Criteo
    // removeCookieByName('cto_bidid');
    removeCookieByName('cto_bundle');
    // Benzinga Deprecated
    removeCookieByName('plus_token');
    // Unknown / Sourcebuster JS
    removeCookieByName('sbjs_', true);
    // ClickFunnels
    removeCookieByName('nextc_', true);
    // HotJar (for later)
    // removeCookieByName('_hjSessionUser', true);
  } catch (err: any) {
    //
  }
};
